/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Privacy_PolicyInputs */

const en_footer_link_privacy_policy = /** @type {(inputs: Footer_Link_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const es_footer_link_privacy_policy = /** @type {(inputs: Footer_Link_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_Link_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_link_privacy_policy = /** @type {((inputs?: Footer_Link_Privacy_PolicyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Privacy_PolicyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_privacy_policy(inputs)
	return en_footer_link_privacy_policy(inputs)
});